import styled from 'styled-components';

import { HOME_HEALTH_AGENCY } from 'constants/locationTypes';
import { useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

import EntitySlideout from './slideout/EntitySlideout';
import NetworkPerformanceSlideout from './slideout/NetworkPerformanceSlideout';
import ProviderPerformanceSection from './table/ProviderPerformanceSection';
import AvgStartOfCareTile from './tiles/AvgStartOfCareTile';
import EngagementsPerPatientTile from './tiles/EngagementsPerPatientTile';
import OesOverviewTile from './tiles/OesOverviewTile';
import ReadmissionRateOverviewTile from './tiles/ReadmissionRateOverviewTile';
import SafeReturnOverviewTile from './tiles/SafeReturnOverviewTile';
import ServiceRefusalsTile from './tiles/ServiceRefusalsTile';

const NetworkPerformanceDashboard = () => {
  const selectedGroupType = useNetworkPerformanceStore((state) => state.selectedGroupType);
  const showServiceRefusals = selectedGroupType?.apiName === HOME_HEALTH_AGENCY;

  return (
    <>
      <DashboardWrapper>
        <MetricsGrid>
          <AvgStartOfCareTile />
          {showServiceRefusals && <ServiceRefusalsTile />}
          <SafeReturnOverviewTile />
          <OesOverviewTile />
          <EngagementsPerPatientTile />
          <ReadmissionRateOverviewTile />
        </MetricsGrid>
        <TableWrapper>
          <ProviderPerformanceSection />
        </TableWrapper>
      </DashboardWrapper>
      <NetworkPerformanceSlideout />
      <EntitySlideout />
    </>
  );
};

export default NetworkPerformanceDashboard;

const DashboardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 394px));
  grid-gap: 24px;
  justify-content: center;

  @media (max-width: 1300px) {
    grid-template-columns: repeat(2, minmax(0, 394px));
  }

  @media (max-width: 960px) {
    grid-template-columns: minmax(0, 394px);
  }
`;

const MetricsGrid = styled.div`
  display: contents;
`;

const TableWrapper = styled.div`
  grid-column: 1 / -1;
`;
